module.exports = __webpack_public_path__ + "img/banner1.c56f158e.png";